/* src/app/views/area-publica/detalhes-projeto/planos-acao-project-public/planos-acao-project-public.component.scss */
.panel-height {
  height: auto;
  padding: 1% 0;
}
.body-content-header {
  font-size: 16px;
  font-weight: 500;
  padding: 0px 56px 0 25px;
}
.body-title {
  text-decoration: none;
  font: normal normal normal 20px/26px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
}
.grey-bg {
  background-color: #fbfbfb !important;
  margin-top: 8px;
  margin-bottom: 8px;
}
.soma {
  text-align: left;
  font: normal normal 600 20px/26px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #007AC2;
}
.box {
  max-height: 37vh;
  width: 100%;
  overflow: auto;
}
.plano-list .plano-detail {
  margin: 1% auto;
  width: 90%;
  border: 1px solid #80BDE0;
  border-radius: 4px;
}
.plano-list .plano-detail .plano-detail-header {
  font-size: 16px;
  font-weight: 500;
  background: #80BDE0 0% 0% no-repeat padding-box;
}
.plano-list .plano-detail .plano-detail-body {
  font-size: 16px;
  font-weight: 500;
  color: #2E3241;
}
.data-plano-header {
  text-align: left;
  font: normal normal normal 12px/26px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #757575;
  text-transform: uppercase;
}
.item-plano-acao-projeto {
  padding: 16px 40px 16px 40px;
  border-top: 1px solid #80BDE0;
}
.header-table-detalhes-plano {
  text-align: center;
  color: #ffffff;
}
.title {
  font-size: 24px;
  padding-top: 40px;
  font-weight: 600;
  color: #007AC2;
}
/*# sourceMappingURL=planos-acao-project-public.component.css.map */
